// Fixed Assets Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get fixedAssetsList from backend then update fixedAssetsList in vuex store ***** //
export const updateFixedAssetsList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('fixed_assets_index', { params: params })
    commit('updateFixedAssetsList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch FixedAsset from backend ***** //
export const fetchFixedAssetInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`fixed_assets_show/${payload}`)
    commit('fetchFixedAssetInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add FixedAsset  ***** //
export const addFixedAsset = async (ignored, payload = null) => {
  try {
    await Axios.post('fixed_assets_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Added Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update FixedAsset  info ***** //
export const updateFixedAssetInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`fixed_assets_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete FixedAsset  ***** //
export const deleteFixedAsset = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`fixed_assets_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}

// ***** Get fullFixedAssetsList from backend then update fullFixedAssetsList in vuex store ***** //
export const updateFullFixedAssetsList = async ({ commit }) => {
  try {
    const result = await Axios.get('fixed_assets_list')
    let list = result.data.data
    let fullList = []
    list.forEach(pt => {
      fullList.push({ value: pt.product_id, text: pt.product_name })
    })
    commit('updateFullFixedAssetsList', fullList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Get fullTransferFixedAssetsList from backend then update fullTransferFixedAssetsList in vuex store ***** //
export const updateFullTransferFixedAssetsList = async ({ commit }) => {
  try {
    const result = await Axios.get('transfer_fixed_asset_list')
    let list = result.data.data
    let fullList = []
    list.forEach(pt => {
      fullList.push({
        value: pt.product_id,
        text: pt.product_name,
        quantity: pt.quantity
      })
    })
    commit('updateFullTransferFixedAssetsList', fullList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}
